<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import InputForm from '@/components/form/InputForm.vue'
import { formDefaultProps } from '@/models/formPartial'
import { normalizeKana } from '@/utilities/formatter'

export default defineComponent({
  name: 'InputFormKana',

  components: {
    InputForm,
  },

  props: {
    ...formDefaultProps,

    modelValue: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue', 'error'],

  setup(props, { emit }) {
    /**
     * かな欄の表記ゆれを取り除いた値を親へ返す
     * @description 入力中（IME 変換中）に書き換えると変換候補の選択を妨げるため、入力欄を離れるまで待つ
     */
    const normalizeModelValue = () => {
      const normalized = normalizeKana(props.modelValue)
      if (normalized !== props.modelValue) emit('update:modelValue', normalized)
    }

    // 登録済みの値の表記ゆれ（カタカナ・半角カナ・空白）は、入力欄に触れないままでも直るように表示された時点で正規化する
    onMounted(normalizeModelValue)

    return {
      // method
      normalizeModelValue,
    }
  }
})
</script>

<template>
  <InputForm
    :model-value="modelValue"
    :header="header"
    :namespace="namespace"
    :name="name"
    :placeholder="placeholder"
    :has-trim="hasTrim"
    :is-disabled="isDisabled"
    :readonly="readonly"
    :validation-scheme="validationScheme"
    @update:model-value="$emit('update:modelValue', $event)"
    @error="$emit('error', $event)"
    @blur="normalizeModelValue" />
</template>
